export default __webpack_public_path__ + "static/kindergarten-readiness6-32a779776b65a1e6c7f510780486e647.jpg";